<template>
  <div>
    <confirm-box :dialog="dialog" @confirmed="deleteData" @cancel="cancel" />
    <v-data-table
      :headers="headers"
      :items="members"
      :loading="loading"
      :items-per-page="itemsPerPage"
      @page-count="pageCount = $event"
      :page.sync="page"
      item-key="id"
      hide-default-footer
      hide-default-header
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Member Account</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn
            to="/member/add"
            color="teal accent-4"
            depressed
            dark
            class="mb-1"
          >
            <v-icon left dark> mdi-plus-circle-outline </v-icon>
            New Item
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:header="{ props: { headers } }">
        <thead class="header">
          <tr>
            <th
              v-for="header in headers"
              :key="header.text"
              class="header--text"
            >
              {{ header.text }}
            </th>
          </tr>
        </thead>
      </template>

      <template v-slot:item="{ index, item }">
        <tr>
          <td>{{ index + 1 }}</td>
          <td>{{ item.username }}</td>
          <td>{{ item.password }}</td>
          <td>
            {{
              item.role == 1
                ? "PD"
                : item.role == 2
                ? "PO"
                : item.role == 3
                ? "MEAL MANAGER"
                : item.role == 4
                ? "MEAL OFFICER"
                : item.role == 5
                ? "PROGRAM MANAGER"
                : item.role == 7
                ? "CLINIC MANAGER"
                : "DPD"
            }}
          </td>
          <td v-if="item.project">{{ item.project == 1 ? "PICTS" : "MDR" }}</td>
          <td v-else></td>

          <td v-if="item.role != 5 && item.role != 7"></td>
          <td
            v-else-if="(item.role == 5 || item.role == 7) && item.project == 1"
          >
            {{ item.township_group_id == 1 ? "PICTS 1" : "PICTS 2" }}
          </td>
          <td
            v-else-if="(item.role == 5 || item.role == 7) && item.project == 2"
          >
            {{ item.township_group_id == 1 ? "MDR 1" : "MDR 2" }}
          </td>

          <td>
            <div>
              <v-btn
                @click="goUpdateForm(item)"
                icon
                color="orange darken-1"
                class="mr-2 white--text"
                depressed
              >
                <v-icon> mdi-pencil-outline </v-icon>
              </v-btn>
              <v-btn
                @click="openConfrimBox(item)"
                icon
                color="red lighten-1"
                class="white--text"
                depressed
              >
                <v-icon> mdi-delete-outline </v-icon>
              </v-btn>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="text-center py-3">
      <v-pagination
        color="purple accent-4"
        v-model="page"
        :length="pageCount"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ConfirmBox from "@/components/notification/ConfirmBox";

export default {
  props: {
    members: {
      type: Array,
    },
  },
  components: {
    ConfirmBox,
  },
  data: () => ({
    pageCount: 0,
    page: 1,
    itemsPerPage: 10,
    item: {},
    dialog: false,
    headers: [
      { text: "No", value: "no" },
      { text: "User Name", value: "username" },
      { text: "Password", value: "password" },
      { text: "Role", value: "role" },
      { text: "Project", value: "project" },
      { text: "Township Group", value: "township_group_id" },
      { text: "Actions", value: "actions", align: "end" },
    ],
  }),
  computed: {
    ...mapState("Loading", ["loading"]),
  },
  methods: {
    openConfrimBox(item) {
      this.item = item;
      this.dialog = !this.dialog;
    },
    deleteData() {
      let data = {
        id: this.item.id,
      };
      this.$store
        .dispatch("Member/delete", data)
        .then(() => (this.dialog = !this.dialog));
    },
    cancel() {
      this.dialog = !this.dialog;
    },
    goUpdateForm(item) {
      this.$router.push({
        name: "edit-member",
        params: {
          id: item.id,
        },
      });
    },
  },
};
</script>

<style scoped></style>
